export const getSavedCustomFilters = (state) =>
  state.conversationsRoute.savedCustomFilters;
export const getPinnedSavedCustomFilters = (state) =>
  state.conversationsRoute.savedCustomFilters.filter(({ pinned }) => pinned);
export const getSavedCustomFiltersPinLimitReached = (state) =>
  Boolean(getPinnedSavedCustomFilters(state).length > 1);
